module.exports = __webpack_public_path__ + "static/media/tnt2x-m.419471b3.jpg";